export const UPSELL_TRANSLATION_TYPE_TITLE = 'title'
export const UPSELL_TRANSLATION_TYPE_DESCRIPTION = 'description'
export const UPSELL_TRANSLATION_TYPE_CONSTITUENTS = 'constituents'

export const getUpsellProductTranslationFromId = (
  id = 0,
  type = UPSELL_TRANSLATION_TYPE_TITLE,
) => {
  const translation = `upsell_${id}_${type}`

  if (!translation) {
    throw new Error(`Translation missing for highlight product number ${id}`)
  }

  return { value: translation }
}
